class NewsletterModal extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      toggleModal: '[toggle-newsletter-modal]',
      modal: '.nl-modal',
      overlay: '.nl-modal__overlay',
    };
    this.modal = this.querySelector(this.selectors.modal);
    this.overlay = this.querySelector(this.selectors.overlay);
    this.closeButton = this.querySelector(this.selectors.toggleModal);

    this.init();
  }

  init() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('customer_posted') === 'true' && window.location.hash === '#ContactFooter') {
      this.showModal();
    } else {
      this.hideModal();
    }

    this.closeButton.addEventListener('click', () => this.hideModal());
    this.overlay.addEventListener('click', () => this.hideModal());
  }

  showModal() {
    this.modal.style.display = 'flex'; // Show the modal

    // Remove query parameters and hash from the URL
    const url = new URL(window.location);
    url.searchParams.delete('customer_posted');
    url.hash = '';
    window.history.replaceState({}, document.title, url.toString());
  }

  hideModal() {
    this.modal.style.display = 'none'; // Hide the modal
  }
}

customElements.define('newsletter-modal', NewsletterModal);